import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TopBar } from "../components/UI";

const API = process.env.REACT_APP_API_URL || "https://g6fw4rjkvb.execute-api.eu-central-1.amazonaws.com/prototype";

export default function SetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => { if (!token) navigate("/"); }, [token]);

  const submit = async () => {
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setLoading(true); setError("");
    try {
      const r = await fetch(`${API}/auth/setup-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || "Failed to set password");
      localStorage.setItem("wine_route_token", d.token);
      setDone(true);
      setTimeout(() => navigate("/road-rep"), 2000);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#F2F5EC" }}>
      <TopBar title="Wine4Collect" />
      <div style={{ maxWidth: 420, margin: "60px auto", padding: "0 16px" }}>
        <div style={{ background: "white", borderRadius: 12, padding: 32, border: "1px solid #C4D0A8" }}>
          {done ? (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 40, marginBottom: 16 }}>✓</div>
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, color: "#3D4A1A", margin: "0 0 8px" }}>Password set!</h2>
              <p style={{ fontSize: 13, color: "#6A7E58" }}>Redirecting to your dashboard…</p>
            </div>
          ) : (
            <>
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, color: "#1E2C14", margin: "0 0 8px" }}>Set your password</h2>
              <p style={{ fontSize: 13, color: "#6A7E58", marginBottom: 24 }}>Welcome to Wine4Collect. Please set a password to activate your account.</p>
              {error && <div style={{ background: "rgba(139,26,47,0.08)", color: "#8B1A2F", padding: "10px 12px", borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 10, fontWeight: 600, color: "#6A7E58", textTransform: "uppercase", letterSpacing: "0.1em", display: "block", marginBottom: 4 }}>New password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="Minimum 8 characters"
                  style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #C4D0A8", background: "#EDF1E4", color: "#2C3820", fontSize: 13, boxSizing: "border-box" }} />
              </div>
              <div style={{ marginBottom: 24 }}>
                <label style={{ fontSize: 10, fontWeight: 600, color: "#6A7E58", textTransform: "uppercase", letterSpacing: "0.1em", display: "block", marginBottom: 4 }}>Confirm password</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && submit()}
                  style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #C4D0A8", background: "#EDF1E4", color: "#2C3820", fontSize: 13, boxSizing: "border-box" }} />
              </div>
              <button onClick={submit} disabled={loading || !password || !confirm}
                style={{ width: "100%", padding: "11px", borderRadius: 8, border: "none", background: "#3D4A1A", color: "white", fontWeight: 600, fontSize: 14, cursor: "pointer", opacity: (loading || !password || !confirm) ? 0.6 : 1 }}>
                {loading ? "Setting password…" : "Activate account →"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
